import { api } from "@/lib/api";

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export async function isPushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function getPushStatus() {
  if (!(await isPushSupported())) return { supported: false, permission: "unsupported", subscribed: false };
  const permission = Notification.permission;
  let subscribed = false;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    subscribed = !!sub;
  } catch {}
  return { supported: true, permission, subscribed };
}

export async function subscribeToPush() {
  if (!(await isPushSupported())) throw new Error("Tu navegador no soporta notificaciones push");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permiso denegado");

  const { data } = await api.get("/push/vapid-public-key");
  if (!data?.key) throw new Error("Servidor sin clave VAPID configurada");

  const reg = await navigator.serviceWorker.ready;
  const existing = await reg.pushManager.getSubscription();
  if (existing) await existing.unsubscribe();

  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlB64ToUint8Array(data.key),
  });

  const subJson = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: subJson.endpoint,
    keys: subJson.keys,
  });
  return true;
}

export async function unsubscribeFromPush() {
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    const subJson = sub.toJSON();
    await sub.unsubscribe();
    try {
      await api.post("/push/unsubscribe", { endpoint: subJson.endpoint, keys: subJson.keys });
    } catch {}
  }
  return true;
}

export async function subscribeCustomerToPush(slug, phone) {
  if (!(await isPushSupported())) throw new Error("Tu navegador no soporta notificaciones push");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permiso denegado");

  const { data } = await api.get("/push/vapid-public-key");
  if (!data?.key) throw new Error("Servidor sin clave VAPID configurada");

  const reg = await navigator.serviceWorker.ready;
  const existing = await reg.pushManager.getSubscription();
  if (existing) await existing.unsubscribe();

  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlB64ToUint8Array(data.key),
  });

  const subJson = sub.toJSON();
  await api.post("/push/customer-subscribe", {
    slug,
    phone,
    endpoint: subJson.endpoint,
    keys: subJson.keys,
  });
  return true;
}

export async function sendTestPush() {
  const { data } = await api.post("/push/test");
  return data;
}
